<template>
  <div
    class="tw-flex xl:tw-justify-between xl:tw-items-center tw-self-stretch tw-px-5 tw-py-3.5 tw-rounded-md noteInfo"
  >
    <div class="tw-flex tw-items-center tw-gap-2.5 tw-w-full main__wrapper">
      <img
        src="/img/bulb_icon.svg"
        alt="bulb"
        class="tw-w-[18px] tw-h-[18px] icon"
        style=""
      />
      <slot class="tw-text-[#211F58] tw-text-[15px]" />
    </div>
    <img
      v-if="showCloseButton"
      src="/img/close_icon.svg"
      alt="close"
      class="tw-w-[11.999px] tw-h-[12px] tw-cursor-pointer tw-z-[1]"
      @click="$emit('close')"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  emits: ["close"],
})
export default class NoteInfo extends Vue {
  @Prop({ required: false }) public text!: string;
  @Prop({ required: false, default: true }) public showCloseButton = true;
  @Prop({ required: false, default: "#D9EDE2" })
  public backgroundColor!: string;
}
</script>

<style scoped>
.icon {
  filter: invert(8%) sepia(29%) saturate(6809%) hue-rotate(237deg)
    brightness(97%) contrast(92%) !important;
}
.noteInfo {
  width: 100%;
  background: v-bind(backgroundColor);
}
</style>
